import React from 'react';
import Layout from '../../../components/Layout';
import HowItWorks from './HowItWorks';
import { trackPageView } from '../../../core/analytics';

const title = 'How it works';

export default {
  path: '/how-it-works',

  action() {
    trackPageView('/how-it-works');
    return {
      title,
      component: (
        <Layout>
          <HowItWorks />
        </Layout>
      ),
    };
  },
};



// WEBPACK FOOTER //
// ./src/routes/static/how-it-works/index.js